@if(showMenu){
  <nav class="menu-horizontal">
    <button matButton [matMenuTriggerFor]="menuTitulos" [class.menu-selected]="router.url.startsWith('/titulos')">Titulos</button>
    <mat-menu #menuTitulos="matMenu">
      <button mat-menu-item routerLink="/titulos" [class.menu-selected]="router.url === '/titulos'">Listado</button>
      <button mat-menu-item routerLink="/titulos/asignar" [class.menu-selected]="router.url === '/titulos/asignar'">Asignar A Persona</button>
    </mat-menu>
    <button matButton [matMenuTriggerFor]="menuCompetencias" [class.menu-selected]="router.url.startsWith('/competencias')">Competencias</button>
    <mat-menu #menuCompetencias="matMenu">
      <button mat-menu-item routerLink="/competencias/por-titulo" [class.menu-selected]="router.url === '/competencias/por-titulo'">Consulta Por Titulo</button>
      <button mat-menu-item routerLink="/competencias/por-dni" [class.menu-selected]="router.url === '/competencias/por-dni'">Consulta Por Dni</button>
    </mat-menu>
    <a routerLink="/materias" routerLinkActive="menu-selected">Materias</a>
    <a routerLink="/planes" routerLinkActive="menu-selected">Planes</a>
    <a routerLink="/establecimientos" routerLinkActive="menu-selected">Establecimientos</a>
  </nav>
}
